/*
 * Shared constants for address forms
 */

// Default form values for address fields
export const DEFAULT_ADDRESS_FIELDS = {
    addressId: '',
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    c_address3: '',
    city: '',
    postalCode: '',
    countryCode: '',
    phone: '',
    companyName: ''
}

// Default form values for shipping address
export const DEFAULT_SHIPPING_VALUES = DEFAULT_ADDRESS_FIELDS

// Default form values for billing address (with billing_ prefix)
export const DEFAULT_BILLING_VALUES = {
    addressId: '',
    billing_firstName: '',
    billing_lastName: '',
    billing_address1: '',
    billing_address2: '',
    billing_c_address3: '',
    billing_city: '',
    billing_postalCode: '',
    billing_countryCode: '',
    billing_phone: '',
    billing_companyName: ''
}

// Helper function to transform address to billing format
export const transformToBillingFormat = (address) => {
    const formData = {addressId: address.addressId || ''}
    Object.keys(address).forEach((key) => {
        if (!['addressId', 'creationDate', 'lastModified', 'preferred', 'fullName'].includes(key)) {
            formData[`billing_${key}`] = address[key]
        } else if (key === 'addressId') {
            formData[key] = address[key]
        }
    })
    return formData
}

// Helper function to compare addresses by their fields (excluding metadata)
export const compareAddresses = (address1, address2) => {
    if (!address1 || !address2) return false

    const cleanAddress = (addr) => {
        if (!addr) return {}
        const {
            id,
            _type,
            fullName,
            companyName,
            addressId,
            creationDate,
            lastModified,
            preferred,
            c_isBillingAddress,
            ...clean
        } = addr
        // Normalize countryCode to uppercase for comparison
        if (clean.countryCode) {
            clean.countryCode = clean.countryCode.toUpperCase()
        }
        return clean
    }

    const address1Clean = cleanAddress(address1)
    const address2Clean = cleanAddress(address2)

    return JSON.stringify(address1Clean) === JSON.stringify(address2Clean)
}

// Helper function to find matching address in customer addresses
export const findMatchingAddress = (selectedAddress, customerAddresses) => {
    if (!selectedAddress || !customerAddresses?.length) return null

    // If addressId or id exists, try searching by ID first (most efficient)
    const addressId = selectedAddress.addressId || selectedAddress.id
    if (addressId) {
        const found = customerAddresses.find((addr) => addr.addressId === addressId)
        if (found) {
            return found
        }
    }

    // If no addressId or ID search failed, search by comparing address fields
    for (let i = 0; i < customerAddresses.length; i++) {
        const addr = customerAddresses[i]
        const isMatch = compareAddresses(selectedAddress, addr)
        if (isMatch) {
            return addr
        }
    }

    return null
}
